import { render } from "./Highlights.vue?vue&type=template&id=82afff76&scoped=true"
import script from "./Highlights.vue?vue&type=script&lang=js"
export * from "./Highlights.vue?vue&type=script&lang=js"

import "./Highlights.vue?vue&type=style&index=0&id=82afff76&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82afff76"]])

export default __exports__